module.exports = __webpack_public_path__ + "Flag-478.339ada903d570df35e666c3fce07ea5d.svg";